import { toast } from 'svelte-french-toast';
export const executePromise = (promise, msgs, opts) => {
    return toast.promise(promise, {
        error: null,
        loading: msgs.loading,
        success: ((data) => {
            if (!data.error) {
                return msgs.success;
            }
            throw new Error(data.error);
        }),
    }, Object.assign({ error: {
            style: 'display: none'
        } }, opts));
};
